<template>
  <div class="dialog-wrap">
    <el-dialog title="联系方式"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @open="handleOpen"
               @close="handleClose"
               width="328px">
      <el-form ref="userForm"
               label-width="55px"
               class="userForm">
        <el-form-item label="手机号">
          <el-input v-model="rowDetail.mobile"
                    style="width:230px"
                    disabled
                    placeholder="请输入手机号"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="微信号">
          <el-input v-model="rowDetail.wechat"
                    style="width:230px"
                    placeholder="请输入微信号"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="QQ号">
          <el-input v-model="rowDetail.qq"
                    style="width:230px"
                    placeholder="请输入QQ号"
                    clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div class="cancle"
             @click="handleClose()">取消</div>
        <div class="confirm"
             @click="handleSubmit()">确定</div>

      </div>

    </el-dialog>

  </div>
</template>
<script>
import { editSeniorApply } from '@/api/senior'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    handleOpen() {},
    handleClose() {
      this.$emit('phoneClose')
    },
    handleSubmit() {
      editSeniorApply({
        id: this.rowDetail.id,
        realname: this.rowDetail.realname,
        wechat: this.rowDetail.wechat,
        gender: this.rowDetail.gender,
        qq: this.rowDetail.qq,
      }).then((res) => {
        this.$message.success(`操作成功`)
        this.handleClose()
      })
    },
  },
}
</script>
<style lang="less" scoped>
.dialog-wrap {
  ::v-deep .el-dialog__header {
    background: #ecf2fe;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    .cancle {
      text-align: center;
      width: 56px;
      height: 36px;
      line-height: 36px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      margin-right: 16px;
    }
    .confirm {
      text-align: center;
      width: 56px;
      color: #fff;
      height: 36px;
      line-height: 36px;
      background: #1f86fe;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
</style>